export const BYO_CLOSE = 'byoClose';
export const BYO_DRIVE_TYPE_CHANGE = 'byoDriveTypeChange';

export const addCustomEvent = (eventType, eventHanddler) => {
  window.addEventListener(eventType, eventHanddler);
};

export const dispatchCustomEvent = (eventType) => {
  window.dispatchEvent(new CustomEvent(eventType));
};

export const removeCustomEvent = (eventType, eventHanddler) => {
  window.removeEventListener(eventType, eventHanddler);
};
